<template>
  <div>
    <div class="info-layout">
      <h3>
        Localization & Currency
        <el-tooltip class="item" effect="dark" content="Reset" placement="top">
          <icon-button icon="el-icon-refresh" @click="$emit('edit')" />
        </el-tooltip>
      </h3>
    </div>
    <div class="input-group">
      <picker
        :api="$api.country().index"
        v-model="formData.countryId"
        class="signup-country-picker"
        value-key="id"
        placeholder="Select your country"
        icon="globe" />
      <picker
        :api="$api.currencies.index"
        v-model="formData.currencyId"
        class="signup-country-picker"
        value-key="id"
        icon="dollar-sign"
        placeholder="Choose your currency" />
    </div>
    <p class="currency-info">
      <i class="el-icon-info" />
      Please note that if you change your currency your saldo will be recalculated using an exchange rate set by Divegas.
    </p>
  </div>
</template>

<script>
import Picker from '@/components/shared/CollectionPicker'

export default {
  name: 'LocalizationDetails',
  components: { Picker },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  watch: {
    formData: {
      handler () {
        this.$emit('change', this.formData)
      },
      deep: true
    }
  },
  data () {
    return {
      formData: {
        currencyId: this.user.currency.id,
        countryId: this.user.country.id
      }
    }
  },
  methods: {
    reset () {
      this.formData.currencyId = this.user.currency.id,
      this.formData.countryId = this.user.country.id
      
      this.$emit('change', this.formData)
    }
  },
  created () {
    this.$emit('change', this.formData)
  }
}
</script>

<style lang="scss" scoped>
  .currency-info {
    position: relative;
    font-size: 12px;
    color: $text-light;
    margin-top: 20px;
    padding-left: 20px;

    i {
      position: absolute;
      left: 0px;
      top: 5px;
    }
  }

  .info-layout {
    padding: 20px 0px 20px 0px;

    h3 {
      padding: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/profile/LocalizationDetails.vue